class VehicleSearchFlex {
  constructor(parent) {
    this.parent = parent;

    this.elements = {
      container: document.querySelector('#js-free-text-search'),
    };

    this.handleClick = this.handleClick.bind(this);
    this.init();
  }

  init() {
    this.elements.container.addEventListener('click', this.handleClick);
  }

  /**
   * Click handler for links in the dropdown list
   * @param {Event} { target }
   */
  handleClick({ target }) {
    if (target?.dataset?.raw) {
      let raw = {};
      try {
        raw = JSON.parse(target.dataset.raw);
      } catch (e) {
        console.log(e);
      }
      // turn raw parameters into filter selections
      const allParams = Object.entries(raw)
        .filter(([field]) => !['language', 'slugs', 'params'].includes(field))
        .map(([field, value]) => ({ field, value }));
      if (raw?.slugs) {
        const slugs = raw.slugs.split('/');
        if (slugs[0]) allParams.push({ field: 'make[]', value: slugs[0] });
        if (slugs[1]) allParams.push({ field: 'model[]', value: slugs[1] });
      }

      if (raw?.params) {
        const params = new URLSearchParams(raw?.params);
        for (const [key, value] of params.entries()) {
          allParams.push({ field: key, value: value });
        }
      }

      this.#handleFields(allParams);

      this.elements.container.classList.remove('show-suggestions');
    }
  }

  /**
   * translates param names into the hybrid search fields which are named differently
   * @param {string} field name of param to translate
   * @returns {string} translated field name
   */
  #mapFieldname(field) {
    const fieldMapping = {
      make: 'make[]',
      model: 'model[]',

      'fueltype[]': 'fuel[]',
      fueltype: 'fuel[]',

      'bodytype[]': 'body_type[]',
      bodytype: 'body_type[]',

      'drivetype[]': 'drive[]',
      drivetype: 'drive[]',

      category: 'category[]',
    };
    return fieldMapping[field] ?? field;
  }

  /**
   * Handles an array of parameters to selected filters
   * @param {object[]} params array of {field, value} pairs
   */
  #handleFields(params) {
    for (let { field, value } of params) {
      const selector = `[name="${this.#mapFieldname(field)}"]`;
      const element = document.querySelector(selector);
      switch (element?.type) {
        case 'select-multiple':
        case 'select-one':
          this.#handleSelect(field, value, element);
          break;
        case 'radio':
        case 'checkbox':
          this.#handleCheckable(selector, field, value);
          break;
        case 'number':
          this.#handleNumber(field, value, element);
          break;
        default:
          console.log('unhandled field type', element?.type, element, field, value, selector);
      }
    }
  }

  /**
   * Selects an option in a select
   * @param {string} _field name of select field to be modified
   * @param {string} value value to select
   * @param {HTMLElement} element handle to the select HTML element
   */
  #handleSelect(_field, value, element) {
    const findOption = [...element.options].find(option => option.value.localeCompare(value, undefined, { sensitivity: 'base' }) === 0);
    if (findOption) {
      element.options[0].selected = false;
      element.options[0].toggleAttribute('selected', false);
      findOption.selected = true;
      element.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /**
   * Sets value to group of checkables
   * @param {string} fieldSelector query selector pointing to the inputs
   * @param {string} field name of checkbox or radio field to be modified
   * @param {string} value value to select
   */
  #handleCheckable(fieldSelector, field, value) {
    const unSelector = `${fieldSelector}:checked`;
    document.querySelector(unSelector)?.toggleAttribute('checked', false);
    const selector = `${fieldSelector}[value="${value}"]`;
    document.querySelector(selector)?.toggleAttribute('checked', true);
  }

  /**
   * Sets value to number field - unsure if this is really used? There didn't seem to be numeric values in the prepoluated searches
   * @param {string} field name of input field to be modified
   * @param {string} value value to set
   * @param {HTMLElement} element input field to be modified
   */
  #handleNumber(field, value, element) {
    element.value = value;
    element.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

export { VehicleSearchFlex };
